import React, { useState } from 'react';
import { ModalX } from '../../../components';
import { Button, Input, Textarea } from '@material-tailwind/react';
import { useAddInventoryPhysicalCount } from '../../../custom-hooks/use-inventory';
import { formatQty, unitLabel } from '../utils';

// Record what's actually on the shelf — mirrors AddTransactionModal's layout/flow.
const PhysicalCountModal = ({ isOpen, onClose, item }) => {
    const [countedQuantity, setCountedQuantity] = useState('');
    const [note, setNote] = useState('');

    const addCountMutation = useAddInventoryPhysicalCount();

    const reset = () => {
        setCountedQuantity('');
        setNote('');
    };

    const handleClose = () => {
        reset();
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!item?._id || countedQuantity === '') return;
        await addCountMutation.mutateAsync({ itemId: item._id, data: { countedQuantity: Number(countedQuantity), note } });
        handleClose();
    };

    if (!item) return null;

    return (
        <ModalX isOpen={isOpen} onClose={handleClose} title={`Record Count — ${item.name}`} maxWidth="md">
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="rounded-xl bg-inv-cream-100 px-3.5 py-2.5 text-sm text-[#6B675F]">
                    System currently shows <span className="font-bold text-inv-ink">{formatQty(item.currentRemaining, item.unitOfMeasure)}</span> remaining
                </div>

                <Input
                    type="number"
                    label={unitLabel('Counted Quantity', item.unitOfMeasure)}
                    value={countedQuantity}
                    onChange={(e) => setCountedQuantity(e.target.value)}
                    min="0"
                    step="any"
                    required
                    autoFocus
                />

                <Textarea label="Note (optional)" value={note} onChange={(e) => setNote(e.target.value)} rows={2} />

                <div className="flex justify-end gap-2 pt-1">
                    <Button variant="text" className="rounded-full" onClick={handleClose} type="button">Cancel</Button>
                    <Button
                        type="submit"
                        className="rounded-full bg-inv-brand shadow-none hover:bg-inv-brand-dark"
                        loading={addCountMutation.isLoading}
                        disabled={countedQuantity === ''}
                    >
                        Record Count
                    </Button>
                </div>
            </form>
        </ModalX>
    );
};

export default PhysicalCountModal;
